export default __webpack_public_path__ + "static/media/a4_portrait.98d1763e.png";